import {
  buildAuthHeaders,
  buildUrl,
} from "../../../../../utils/requestToolsV3";
import { searchV3 } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP_V3}/main/taxation/nbs`;
const headers = buildAuthHeaders();

export async function getNbsList({ filters = {} }) {
  const url = buildUrl({ path, filters });

  return searchV3(url, "GET", headers);
}
